var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatisticsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:query-stats"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.625 18.175L1 17L6 9L9 12.5L13 6L15.725 10.075C15.3417 10.0917 14.979 10.1377 14.637 10.213C14.295 10.2883 13.9577 10.3923 13.625 10.525L13.075 9.7L9.275 15.875L6.25 12.35L2.625 18.175ZM21.575 23L18.45 19.875C18.1167 20.1083 17.7457 20.2833 17.337 20.4C16.9283 20.5167 16.5077 20.575 16.075 20.575C14.825 20.575 13.7623 20.1373 12.887 19.262C12.0117 18.3867 11.5743 17.3243 11.575 16.075C11.575 14.825 12.0127 13.7623 12.888 12.887C13.7633 12.0117 14.8257 11.5743 16.075 11.575C17.325 11.575 18.3877 12.0127 19.263 12.888C20.1383 13.7633 20.5757 14.8257 20.575 16.075C20.575 16.5083 20.5167 16.9293 20.4 17.338C20.2833 17.7467 20.1083 18.1257 19.875 18.475L23 21.575L21.575 23ZM16.075 18.575C16.775 18.575 17.3667 18.3333 17.85 17.85C18.3333 17.3667 18.575 16.775 18.575 16.075C18.575 15.375 18.3333 14.7833 17.85 14.3C17.3667 13.8167 16.775 13.575 16.075 13.575C15.375 13.575 14.7833 13.8167 14.3 14.3C13.8167 14.7833 13.575 15.375 13.575 16.075C13.575 16.775 13.8167 17.3667 14.3 17.85C14.7833 18.3333 15.375 18.575 16.075 18.575ZM18.3 10.575C17.9833 10.4417 17.654 10.3333 17.312 10.25C16.97 10.1667 16.616 10.1167 16.25 10.1L21.375 2L23 3.175L18.3 10.575Z",
    fill: "#ADADB0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsInactive);
export default __webpack_public_path__ + "static/media/statistics_inactive.530e732f3577a31f29655739d8ff35bf.svg";
export { ForwardRef as ReactComponent };